import { createCpmsBoTariffSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-tariff.slice';

import { cpmsBoTariffApi } from './cpms-bo-tariff.service';

export const cpmsBoTariffSlice = createCpmsBoTariffSlice({ cpmsBoTariffApi });
